module.exports = __webpack_public_path__ + "static/media/suggestion_gray.311db333.svg";